import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c7784e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-detail" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"margin-left":"10px","margin-bottom":"10px"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "el-upload-list__item-actions" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("撤回")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("返回列表")
const _hoisted_15 = ["src"]

import { Plus, UploadFilled } from "@element-plus/icons-vue";
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type {
  UploadFile,
  ElUploadProgressEvent,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

interface activityVo {
  id: string;
  projectId: string;
  type: string;
  status: number;
  name: string;
  province: string;
  city: string;
  area: string;
  address: string;
  contact: string;
  mobile: string;
  startTime: string;
  endTime: string;
  paymentModel: string;
  paymentWay: string;
  joinCategoryIds: string;
  tempJoinCategoryIds: string[];
  joinQuantity: string;
  request: string;
  activityImages: activityImageVo[];
  imgUrlJson: string;
}
interface activityImageVo {
  uid: number;
  imgUrl: string;
  thumbnailUrl: string;
  url: string;
}

interface imageVo {
  imageUriList: activityImageVo[];
}
type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const isEdit = ref(true);
const imageVo: imageVo = {
  imageUriList: [],
};

const createOrEditFormData: activityVo = {
  id: "",
  projectId: "",
  type: "1",
  status: 1,
  name: "",
  province: "",
  city: "",
  area: "",
  address: "",
  startTime: "",
  endTime: "",
  contact: "",
  mobile: "",
  paymentModel: "",
  paymentWay: "",
  joinCategoryIds: "",
  tempJoinCategoryIds: [],
  joinQuantity: "",
  request: "",
  activityImages: [],
  imgUrlJson: "",
};
const investFormRef = ref<FormInstance>();
const bindData = reactive({
  createOrEditFormData: createOrEditFormData,
  imageVo: imageVo,
  projects: [],
  joinCategorys: [],
  actionUrl: tool.url("/middle/activity/uploadActivityImg"),
  areaId: "",
  joinCategoryName: "",
});

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  bindData.createOrEditFormData.id = id;
} else {
  var i;
  for (i = 0; i < id.length; i++) {
    bindData.createOrEditFormData.id = id[i];
  }
}



const investRules = reactive({
  name: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
  startTime: [{ required: true, message: "请输入起止时间", trigger: "change" }],
  contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
  mobile: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
});

const saveEvent = (formEl: FormInstance | undefined,status: number) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      var id = bindData.createOrEditFormData.id;
      if ("add" == id) {
        bindData.createOrEditFormData.id = "";
      }
      if (status) {
        bindData.createOrEditFormData.status = status;
      }
      bindData.createOrEditFormData.imgUrlJson = JSON.stringify(
        bindData.imageVo.imageUriList
      );
      var joinCategoryIds = "";
      var tempJoinCategoryIds =
        bindData.createOrEditFormData.tempJoinCategoryIds;
      if (tempJoinCategoryIds) {
        for (var value of tempJoinCategoryIds) {
          if (!joinCategoryIds) {
            joinCategoryIds = value;
          } else {
            joinCategoryIds = joinCategoryIds + "," + value;
          }
        }
      }
      bindData.createOrEditFormData.joinCategoryIds = joinCategoryIds;
      store
        .dispatch("investModule/saveActivity", bindData.createOrEditFormData)
        .then(
          (data) => {
            bindData.createOrEditFormData.id = data.result;
            ElMessage.success(data.msg);
            isEdit.value = true;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const updateActivityStatusEvent = (status: number) => {
  var id = bindData.createOrEditFormData.id;
  if ("add" == id) {
    bindData.createOrEditFormData.id = "";
  }
  var msg = "您确定要发布吗?";
  if (status == 1) {
    var msg = "您确定要撤回吗?";
  }
  ElMessageBox.confirm(msg)
    .then(() => {
      const params = {
        id: id,
        status: status,
      };
      store.dispatch("investModule/updateActivityStatus", params).then(
        (data) => {
          //成功
          ElMessage.success("成功.");
          activityEvent();
          activityImageEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const projectEvent = () => {
  store
    .dispatch("investModule/listProject", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.projects = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const joinCategoryEvent = () => {
  store
    .dispatch("investModule/listJoinCategory", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.joinCategorys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityEvent = () => {
  store
    .dispatch("investModule/getActivity", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.createOrEditFormData = data.result;
        bindAreaData(data.result.area);
        var joinCategoryIds = bindData.createOrEditFormData.joinCategoryIds;
        if (joinCategoryIds) {
          bindData.createOrEditFormData.tempJoinCategoryIds =
            joinCategoryIds.split(",");
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityImageEvent = () => {
  store
    .dispatch("investModule/listActivityImage", bindData.createOrEditFormData)
    .then(
      (data) => {
        //成功
        bindData.imageVo.imageUriList = [];
        var index = 1;
        for (var image of data.result) {
          const imageFile: activityImageVo = {
            uid: index,
            imgUrl: image.imgUrl,
            thumbnailUrl: image.thumbnailUrl,
            url: image.thumbnailUrl,
          };
          bindData.imageVo.imageUriList.push(imageFile);
          index++;
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const saveJoinCategoryEvent = () => {
  store
    .dispatch("investModule/saveJoinCategory", {
      joinCategoryName: bindData.joinCategoryName,
    })
    .then(
      (data) => {
        ElMessage.success("成功.");
        joinCategoryEvent();
        bindData.joinCategoryName = "";
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

joinCategoryEvent();
projectEvent();
var lid = bindData.createOrEditFormData.id;
if (lid && lid != "add") {
  activityEvent();
  activityImageEvent();
} else {
  isEdit.value = false;
}
const toInvestDetail = (id: string) => {
  router.push("/middleGround/invest/investList/investDetail/" + id);
};

const toInvestList = () => {
  router.push("/middleGround/invest/investList");
};

const handleRemove = (file: UploadFile, fileList: UploadFile[]) => {
  const imageUriList = bindData.imageVo.imageUriList;
  bindData.imageVo.imageUriList = [];
  //成功
  for (var image of imageUriList) {
    if (image.uid != file.uid) {
      bindData.imageVo.imageUriList.push(image);
    }
  }
};

const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};

const uploadSuccessEvent = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  const activityImageVo: activityImageVo = {
    uid: file.uid,
    imgUrl: response.result,
    url: file.url!,
    thumbnailUrl: "",
  };
  bindData.imageVo.imageUriList.push(activityImageVo);
};

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    //省
    const firstValue = value[value.length - 3];
    var province = tool.areaCodeToText.get(firstValue);
    if (province != undefined) {
      bindData.createOrEditFormData.province = province;
    }
    //市
    const secordValue = value[value.length - 2];
    var city = tool.areaCodeToText.get(secordValue);
    if (city != undefined) {
      bindData.createOrEditFormData.city = city;
    }
    //取最后一个
    const lastValue = value[value.length - 1];
    var areaName = tool.areaCodeToText.get(lastValue);
    bindData.areaId = lastValue;
    if (areaName != undefined) {
      bindData.createOrEditFormData.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  var areaValue = tool.areaTextToCode.get(areaName);
  if (areaValue != undefined) {
    bindData.areaId = areaValue;
  }
};

const handleEdit = () => {
  isEdit.value = false;
};
const handleSub = () => {
  isEdit.value = true;
};

const handleDisabledDate = (time: any) => {
  const beginDateVal = new Date(
    bindData.createOrEditFormData.startTime
  ).getTime();
  if (beginDateVal) {
    return time.getTime() < beginDateVal;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      mode: _ctx.form,
      "label-width": "120px",
      rules: _unref(investRules),
      ref_key: "investFormRef",
      ref: investFormRef,
      model: _unref(bindData).createOrEditFormData
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "所属项目" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.projectId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).createOrEditFormData.projectId) = $event)),
              disabled: isEdit.value,
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projects, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "活动标题",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "请输入活动标题",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "起止日期",
          prop: "startTime"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(bindData).createOrEditFormData.startTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).createOrEditFormData.startTime) = $event)),
              disabled: isEdit.value,
              style: {"width":"140px","margin-right":"5px"},
              "value-format": "YYYY-MM-DD",
              type: "date",
              placeholder: "开始日期"
            }, null, 8, ["modelValue", "disabled"]),
            _hoisted_2,
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(bindData).createOrEditFormData.endTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).createOrEditFormData.endTime) = $event)),
              disabled: isEdit.value,
              "value-format": "YYYY-MM-DD",
              style: {"width":"140px","margin-left":"5px"},
              type: "date",
              placeholder: "结束日期",
              "disabled-date": handleDisabledDate
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "活动地点" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              disabled: isEdit.value,
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).areaId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).areaId) = $event))
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled", "options", "modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.address) = $event)),
              disabled: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'},{marginTop: '4px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "联系人",
          prop: "contact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.contact,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.contact) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "联系电话",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.mobile,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.mobile) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "收费模式" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.paymentModel,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.paymentModel) = $event)),
              disabled: isEdit.value,
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "一次性进场费",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "进场费+销售提成",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "销售提成",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "包盘（一次性进场费）",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "包盘（进场费+销售提成)",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "面议",
                  value: 6
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "收款模式" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.paymentWay,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).createOrEditFormData.paymentWay) = $event)),
              disabled: isEdit.value,
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "公司代收货款",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "公司不代收货款",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "其他",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "招商品类" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _unref(bindData).createOrEditFormData.tempJoinCategoryIds,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).createOrEditFormData.tempJoinCategoryIds) = $event)),
                disabled: isEdit.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategorys, (item) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: item.id,
                      label: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).joinCategoryName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).joinCategoryName) = $event)),
                readonly: isEdit.value,
                onBlur: saveJoinCategoryEvent,
                "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'100px'},{float:'right'}],
                placeholder: "自定义",
                size: "default"
              }, null, 8, ["modelValue", "readonly", "input-style"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "招商数量" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.joinQuantity,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).createOrEditFormData.joinQuantity) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "图片" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: _unref(bindData).actionUrl,
              "file-list": _unref(bindData).imageVo.imageUriList,
              "on-success": uploadSuccessEvent,
              "list-type": "picture-card",
              "auto-upload": true,
              disabled: isEdit.value,
              multiple: false,
              "with-credentials": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (!isEdit.value)
                      ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_7),
                    (!isEdit.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["action", "file-list", "disabled"]),
            _createVNode(_component_el_dialog, {
              modelValue: dialogVisible.value,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  width: "100%",
                  src: dialogImageUrl.value,
                  alt: ""
                }, null, 8, _hoisted_9)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "要求" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.request,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(bindData).createOrEditFormData.request) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')}],
              type: "textarea",
              autosize: { minRows: 4, maxRows: 8 },
              autocomplete: "off"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["mode", "rules", "model"]),
    _createVNode(_component_el_container, { class: "invest-detail-btn" }, {
      default: _withCtx(() => [
        (isEdit.value && _unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              onClick: handleEdit,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isEdit.value && _unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              type: "danger",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (saveEvent(investFormRef.value,1))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(bindData).createOrEditFormData.status == 1)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 2,
              type: "primary",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (saveEvent(investFormRef.value,2))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
          _unref(bindData).createOrEditFormData.status > 1 &&
          _unref(bindData).createOrEditFormData.status <= 3
        )
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 3,
              type: "primary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (updateActivityStatusEvent(1))),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(ElButton), {
          size: "large",
          onClick: toInvestList
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_15)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})